module.exports = __webpack_public_path__ + "static/20180215_222239_2-ca7c3a6a599f9bb26211f56e6fe809a9.webp";